import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/auth";
import axios from "axios";
import { backendlink } from "../../config";

export default function PartnerPatientInfoList({ fetchTrigger }) {
  const { user } = useAuth();

  const navigate = useNavigate();

  const [patient, setPatient] = useState([]);
  const [patientToken, setPatientToken] = useState("");

  const location = useLocation();

  const [additionalAttributes, setAdditionalAttributes] = useState([]);

  const getPatientAttribute = async () => {
    try {
      const response = await axios.get(
        backendlink + "partner/getpatientattribute",
        {
          params: {
            organizationToken: location.state.organizationToken,
            userToken: location.state.patientToken,
          },
          headers: {
            token: user.token,
          },
        }
      );

      if (response?.data?.errorno === 0 && response?.data?.result?.length > 0) {
        const mappedAttributes = response?.data?.result?.map((attribute) => {
          return {
            label: attribute.name,
            value: attribute.value,
            dataField: attribute.code,
          };
        });

        setAdditionalAttributes(mappedAttributes);
      } else {
        console.log(response?.data?.errmessage);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (location.state?.patientToken == null) {
      navigate("/");
    } else {
      setPatientToken(location.state.patientToken);
      getPatientAttribute();

      const fetchData = async () => {
        try {
          const response = await axios.post(
            backendlink + "partner/getpatient",
            {
              usertoken: user.userToken,
              patienttoken: location.state.patientToken,
            },
            {
              headers: {
                token: user.token,
              },
            }
          );

          if (response.data.errorno === 0) {
            const outputArray = response.data.result.map((item) => {

              var statusString =
                item.isEnabled === true ? "Active" : "Inactive";
              var countryCodeString = item.countryCode
                ? item.countryCode.replace(/[^0-9+]/g, "")
                : "";
              var phoneForOtpString = item.phoneForOtp
                ? item.phoneForOtp.replace(/[^0-9+]/g, "")
                : "";

              var preferredLanguageString = "Traditional Chinese";
              if (item.preferredLanguage === "en") {
                preferredLanguageString = "English";
              } else if (item.preferredLanguage === "sc") {
                preferredLanguageString = "Simplified Chinese";
              }
              var genderString = "";
              if (item.gender === "M") {
                genderString = "Male";
              } else if (item.gender === "F") {
                genderString = "Female";
              } else if (item.gender === "NA") {
                genderString = "Not specify";
              }

              setPatient({
                name: item.name,
                linkedCustomerToken: item.linkedcustomertoken,
                linkedCustomerName: item.linkedcustomer,
                linkedDoctorToken: item.parentUserToken,
                linkedDoctorName: item.linkeddoctor,
                address: item.description0,
                gender: genderString,
                dob: item.dob,
                contactPerson: item.description1,
                email: item.email,
                phone: item.phone,
                countryCode: String(countryCodeString),
                phoneForOtp: String(phoneForOtpString),
                loginEmail: item.username,
                preferredLanguage: preferredLanguageString,
                status: statusString,
                ...additionalAttributes.reduce((acc, field) => {
                  return { ...acc, [field.dataField]: field.value };
                }, {}),
              });
            });
          } else {
            alert(response.data.errmessage);
          }
        } catch (error) {
          alert(error);
        }
      };

      fetchData();
    }
  }, [user, fetchTrigger]);

  return (
    <div className="card-container">
      <div className="card">
        <h2>Patient Information</h2>
        <div className="user-info">
          <div className="user-info-item">
            <span className="label">Patient Name:</span>
            <span className="value">{patient.name}</span>
          </div>
          <div className="user-info-item">
            <span className="label">Linked Organization:</span>
            <span className="value">{patient.linkedCustomerName}</span>
          </div>
          <div className="user-info-item">
            <span className="label">Linked Doctor:</span>
            <span className="value">{patient.linkedDoctorName}</span>
          </div>
          <div className="user-info-item">
            <span className="label">Address:</span>
            <span className="value">{patient.address}</span>
          </div>
          <div className="user-info-item">
            <span className="label">Gender:</span>
            <span className="value">{patient.gender}</span>
          </div>
          <div className="user-info-item">
            <span className="label">Date of Birth:</span>
            <span className="value">{patient.dob}</span>
          </div>
          <div className="user-info-item">
            <span className="label">Preferred Language:</span>
            <span className="value">{patient.preferredLanguage}</span>
          </div>
          <div className="user-info-item">
            <span className="label">Status:</span>
            <span className="value">{patient.status}</span>
          </div>
          <div className="user-info-item">
            <span className="label">Login Phone Number:</span>
            <span className="value">
              {patient.phoneForOtp
                ? `+${patient.countryCode}-${patient.phoneForOtp}`
                : "NA"}
            </span>
          </div>
          <div className="user-info-item">
            <span className="label">Login Email:</span>
            <span className="value">{patient.loginEmail}</span>
          </div>
          <div className="user-info-item">
            <span className="label">Contact Person:</span>
            <span className="value">{patient.contactPerson}</span>
          </div>
          <div className="user-info-item">
            <span className="label">Contact Number:</span>
            <span className="value">{patient.phone}</span>
          </div>
          <div className="user-info-item">
            <span className="label">Contact Email:</span>
            <span className="value">{patient.email}</span>
          </div>
          {additionalAttributes.map(
            (attribute) =>
              attribute.value && (
                <div key={attribute.dataField} className="user-info-item">
                  <span className="label">{attribute.label}:</span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: attribute.value.replace(/\n/g, "<br />"),
                    }}
                  />
                </div>
              )
          )}
          {/* Add more fields as needed */}
        </div>
      </div>
    </div>
  );
}